// Browser stub — bufferutil is a native Node.js addon not needed in the browser
module.exports = {};
